import "../global.css";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import OverlayForm from "../components/OverlayForm";
import { Helmet } from "react-helmet-async";

/* Colore solido richiesto per la tabella USE CASE (niente gradiente su questa pagina) */
const KIMBALL_PINK = "#E6007E";

/* Blocco statistica locale: come <Counter type="custom" /> ma con tipografia
   responsive, così stringhe lunghe (es. "NARROW/WIDE") non vengono tagliate
   alla larghezza iPad, dove le 3 colonne sono più strette. */
const KimballStat: React.FC<{ value: string; label: string }> = ({
  value,
  label,
}) => (
    <div className="text-center px-2 py-4 min-w-0">
      <div className="font-bold uppercase leading-tight tracking-tight break-words text-3xl md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl">
        {value}
      </div>
      <div className="uppercase pt-3 md:pt-4 leading-snug break-words text-lg md:text-sm lg:text-base xl:text-lg 2xl:text-xl">
        {label}
      </div>
    </div>
);

/* -------------------------------------------------------------------------- */
/*  CUSTOMIZATION OPTIONS                                                     */
/* -------------------------------------------------------------------------- */

/* Stessa card a bordo sfumato usata da PAVEL (CustomizePavel.tsx): valori
   identici, 4px di bordo e fondo #0a0a0a. */
const GradientBorderCard: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className = "" }) => (
    <div
        className={`relative ${className}`}
        style={{
          background:
              "linear-gradient(#0a0a0a, #0a0a0a) padding-box, linear-gradient(90deg, #00858F, #E6007E) border-box",
          border: "4px solid transparent",
        }}
    >
      {children}
    </div>
);

/* Stesse chiavi di customOptions in CustomizePavel, così l'elenco si rende
   con lo stesso markup: quadratino sfumato, label e sottotitolo. */
const CUSTOMIZATION_OPTIONS = [
  {
    label: "RUGGEDIZED OPTICS",
    sub: "Available in S-Mount and C-Mount formats",
  },
  {
    label: "ONBOARD STORAGE OPTIONS",
    sub: "",
  },
  {
    label: "COMPATIBLE SENSOR FORMATS",
    sub: "Currently tested: 5 MP and 8 MP in VIS format",
  },
];

export default function Product_KIMBALL() {
  useEffect(() => {
    if (window.location.hash) {
      let newPath = window.location.pathname + window.location.search;
      if (newPath.endsWith("/")) {
        newPath = newPath.slice(0, -1);
      }
      window.history.pushState("", document.title, newPath);
    }
  }, []);

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleRequestClick = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  return (
      <div>
        <Helmet>
          <title>KIMBALL | Revolv Space</title>
          <meta
              name="description"
              content="KIMBALL is an integrated inspection camera system with 360 deg rotation capability, developed in partnership with Scanway."
          />
        </Helmet>

        {/* IMMAGINE PRODOTTO — solo DESKTOP.
            Centrata con left/right:0 (il top resta quello statico) e dimensionata
            in vw con un minimo e un massimo: così non si rimpicciolisce su iPad
            e non diventa gigante su 4K. */}
        <div className="hidden md:flex absolute left-0 right-0 mt-[1rem] justify-center pointer-events-none">
          <img
              src="/products/Kimball/KIMBALL.png"
              alt="KIMBALL inspection camera system"
              className="w-[40vw] min-w-[320px] max-w-[620px] h-auto object-contain opacity-100 bg-transparent"
              data-aos="fade-zoom-in"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
              data-aos-once="true"
          />
        </div>

        <div className="relative flex flex-col h-full mt-8 md:mt-20">
          {/* ── TITLE SECTION ── 1 colonna su mobile, 2 su desktop */}
          {/* Nessun max-width qui: il margine esterno del titolo deve restare
              allineato a SARA / HOLLY / MARA / PAVEL (mx-12 sull'h1, 48px). */}
          <div className="grid grid-cols-1 md:grid-cols-2 z-40 mb-4">
            <div>
              <h1 className="opacity-0 animate-fadeIn delay-0 md:w-4/6 mx-12 mt-24 md:mt-24 2xl:text-7xl xl:text-7xl lg:text-7xl text-4xl leading-120 tracking-tighter text-left uppercase font-bold text-white dark:text-white">
                KIMBALL
              </h1>

              {/* IMMAGINE PRODOTTO — solo MOBILE (in-flow, impilata) */}
              <img
                  src="/products/Kimball/KIMBALL.png"
                  alt="KIMBALL inspection camera system"
                  className="block md:hidden w-[70vw] max-w-[360px] h-auto mx-auto my-4 opacity-100"
                  data-aos="fade-zoom-in"
                  data-aos-offset="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  data-aos-once="true"
              />

              <div className="opacity-0 animate-fadeIn delay-1 mx-12 uppercase text-base md:text-base lg:text-xl xl:text-2xl 2xl:text-2xl pt-8 md:pt-12 lg:pt-20 text-white leading-34 tracking-tight text-left max-w-full md:max-w-1/2">
                INTEGRATED INSPECTION
                <br />CAMERA SYSTEM
                <br />WITH 360 DEG ROTATION
                <br />CAPABILITY
              </div>
            </div>

            {/* ── IN PARTNERSHIP WITH SCANWAY ── */}
            <div className="col-span-1 flex justify-center md:justify-end items-start z-40 mt-12 md:mt-24 px-8 md:px-0 md:mr-12 lg:mr-20">
              <div className="flex flex-col items-center md:items-end">
                <p className="uppercase font-bold text-white text-sm md:text-sm lg:text-base 2xl:text-lg tracking-wide text-center md:text-right whitespace-nowrap">
                  IN PARTNERSHIP WITH
                </p>
                <img
                    src="/products/Kimball/scanway-logo.svg"
                    alt="Scanway"
                    className="mt-3 h-8 md:h-8 lg:h-10 2xl:h-12 w-auto"
                />
              </div>
            </div>
          </div>

          {/* ── CTA BUTTONS ── */}
          <div
              className="flex flex-col sm:flex-row justify-center items-center mt-4 gap-2 md:gap-12 py-12 font-bold"
              data-aos="fade-zoom-in"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
          >
            <a href="/pdf/Revolv Space - KIMBALL datasheet.pdf" download="KIMBALL-datasheet.pdf">
              <button
                  className="rounded-full w-auto h-12 text-center text-white px-8 transform transition-transform duration-200 hover:scale-110"
                  style={{
                    background: "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
                  }}
              >
                DOWNLOAD DATASHEET
              </button>
            </a>

            <button
                className="rounded-full w-auto h-12 text-center text-white px-8 transform transition-transform duration-200 hover:scale-110"
                style={{
                  background: "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
                }}
                onClick={() => handleRequestClick()}
            >
              REQUEST QUOTATION
            </button>
          </div>

          {/* ── ANIMATED BLOCKS ── */}
          <div className="h-full flex flex-col z-0 my-20">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 px-4 md:px-2 sm:mt-0 text-white">
              <KimballStat value="CAMERA" label="CONTROLLER" />
              <KimballStat value="ACTUATION" label="SYSTEM" />
              <KimballStat value="NARROW/WIDE" label="CAMERA ANGLE" />
            </div>
          </div>

          <div id="main-features" className="h-20"></div>

          {/* ── SHOT WITH KIMBALL SPACE CAMERA ── */}
          <div className="h-full flex flex-col bg-black bg-opacity-50 z-40 mb-24 md:mb-32">
            <h1
                data-aos="fade-zoom-in"
                data-aos-offset="300px"
                data-aos-delay="0"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
                className="my-12 px-4 text-3xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white"
            >
              SHOT WITH KIMBALL
              <br />SPACE CAMERA
            </h1>

            <figure
                className="w-full max-w-[1100px] mx-auto px-4 md:px-8"
                data-aos="fade-zoom-in"
                data-aos-offset="200px"
                data-aos-delay="300"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
            >
              {/* width/height espliciti: fissano il rapporto 16:9 e prevengono
                  lo scatto del layout mentre la foto carica. */}
              <img
                  src="/products/Kimball/shot-with-kimball.jpg"
                  alt="Earth seen from orbit, captured by the KIMBALL space camera aboard ESA YPSat"
                  width={1920}
                  height={1080}
                  loading="lazy"
                  className="w-full h-auto object-contain"
              />
              <figcaption className="mt-4 text-center text-xs md:text-sm uppercase tracking-widest text-white">
                CREDITS:{" "}
                <a
                    href="https://scanway.pl/en/space-cameras/scanway-camera-system/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline underline-offset-2 hover:opacity-80 transition-opacity"
                >
                  SCANWAY
                </a>
              </figcaption>
            </figure>
          </div>

          {/* ── WHY KIMBALL ── */}
          <div className="h-full flex flex-col bg-black bg-opacity-50 z-40 mt-4 mb-40">
            <h1
                data-aos="fade-zoom-in"
                data-aos-offset="300px"
                data-aos-delay="0"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
                className="my-12 text-4xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white"
            >
              WHY KIMBALL
            </h1>

            <div
                className="w-full max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-16 md:gap-y-20 px-4 md:px-10 lg:px-20 mt-8"
                data-aos="zoom-out-in"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
            >
              <div
                  className="value-item flex flex-col items-center text-center"
                  data-aos="fade-zoom-in"
                  data-aos-offset="300px"
                  data-aos-delay="400"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
              >
                <img
                    src="/products/Kimball/small-camera.png"
                    alt=""
                    className="h-20 lg:h-24 2xl:h-28 w-auto mb-6 lg:mb-8"
                />
                <p className="uppercase font-bold text-white text-xl md:text-xl lg:text-2xl xl:text-3xl leading-tight max-w-md break-words">
                  SMALL CAMERA FORM FACTOR
                </p>
              </div>

              <div
                  className="value-item flex flex-col items-center text-center"
                  data-aos="fade-zoom-in"
                  data-aos-offset="300px"
                  data-aos-delay="600"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
              >
                <img
                    src="/products/Kimball/360-degrees.png"
                    alt=""
                    className="h-20 lg:h-24 2xl:h-28 w-auto mb-6 lg:mb-8"
                />
                <p className="uppercase font-bold text-white text-xl md:text-xl lg:text-2xl xl:text-3xl leading-tight max-w-md break-words">
                  360° MOVEMENT
                </p>
              </div>

              <div
                  className="value-item flex flex-col items-center text-center"
                  data-aos="fade-zoom-in"
                  data-aos-offset="300px"
                  data-aos-delay="800"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
              >
                <img
                    src="/products/Kimball/sync-kimball.png"
                    alt=""
                    className="h-20 lg:h-24 2xl:h-28 w-auto mb-6 lg:mb-8"
                />
                <p className="uppercase font-bold text-white text-xl md:text-xl lg:text-2xl xl:text-3xl leading-tight max-w-md break-words">
                  TIME SYNCHRONIZATION VIA PPS SIGNAL
                </p>
              </div>

              <div
                  className="value-item flex flex-col items-center text-center"
                  data-aos="fade-zoom-in"
                  data-aos-offset="300px"
                  data-aos-delay="1000"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
              >
                <img
                    src="/products/Kimball/onboard-folder.png"
                    alt=""
                    className="h-20 lg:h-24 2xl:h-28 w-auto mb-6 lg:mb-8"
                />
                <p className="uppercase font-bold text-white text-xl md:text-xl lg:text-2xl xl:text-3xl leading-tight max-w-md break-words">
                  ONBOARD IMAGE COMPRESSION AND VIDEO ENCODING
                </p>
              </div>
            </div>
          </div>

          {/* ── USE CASE ── */}
          <div className="h-full flex flex-col bg-black bg-opacity-50 z-40 mb-40">
            <h1
                data-aos="fade-zoom-in"
                data-aos-offset="300px"
                data-aos-delay="0"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
                className="my-12 text-3xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white"
            >
              USE CASES
            </h1>

            {/* Tabella a colore solido E6007E — su questa pagina NIENTE gradiente */}
            <div
                className="w-full max-w-[1100px] mx-auto px-4 md:px-8"
                data-aos="fade-zoom-in"
                data-aos-offset="200px"
                data-aos-delay="300"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
            >
              <table
                  className="w-full table-fixed border text-white uppercase"
                  style={{ borderColor: KIMBALL_PINK }}
              >
                <tbody>
                <tr>
                  <td
                      className="w-1/2 border px-3 py-6 sm:px-6 sm:py-8 lg:py-10 text-center align-middle font-bold leading-tight break-words text-sm sm:text-base lg:text-lg xl:text-xl"
                      style={{ borderColor: KIMBALL_PINK }}
                  >
                    Visual inspection of in-orbit deployment
                    (solar panels, sails, other satellites)
                  </td>
                  <td
                      className="w-1/2 border px-3 py-6 sm:px-6 sm:py-8 lg:py-10 text-center align-middle font-bold leading-tight break-words text-sm sm:text-base lg:text-lg xl:text-xl"
                      style={{ borderColor: KIMBALL_PINK }}
                  >
                    VISUAL DATA FOR IN-ORBIT RPOD
                  </td>
                </tr>
                <tr>
                  <td
                      className="w-1/2 border px-3 py-6 sm:px-6 sm:py-8 lg:py-10 text-center align-middle font-bold leading-tight break-words text-sm sm:text-base lg:text-lg xl:text-xl"
                      style={{ borderColor: KIMBALL_PINK }}
                  >
                    SPACE SITUATION AWARENESS
                  </td>
                  <td
                      className="w-1/2 border px-3 py-6 sm:px-6 sm:py-8 lg:py-10 text-center align-middle font-bold leading-tight break-words text-sm sm:text-base lg:text-lg xl:text-xl"
                      style={{ borderColor: KIMBALL_PINK }}
                  >
                    VISUAL INSPECTION OF CRITICAL MECHANISMS, THERMAL INSULATION, DAMAGE OBSERVATION
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* ── CUSTOMIZATION OPTIONS ── */}
          <div className="h-full flex flex-col bg-black bg-opacity-50 z-40 mb-40">
            <h1
                data-aos="fade-zoom-in"
                data-aos-offset="300px"
                data-aos-delay="0"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
                className="my-12 px-4 text-3xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white"
            >
              CUSTOMIZATION OPTIONS
            </h1>

            <div
                className="w-full max-w-[1100px] mx-auto px-4 md:px-8"
                data-aos="fade-zoom-in"
                data-aos-offset="200px"
                data-aos-delay="300"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
            >
              <GradientBorderCard className="p-7 flex flex-col gap-5">
                <ul className="flex flex-col flex-1 justify-around">
                  {CUSTOMIZATION_OPTIONS.map((item, i, arr) => (
                      <li key={item.label}>
                        <div className="flex items-start gap-4 py-3">
                          <span
                              className="flex-shrink-0 w-2 h-2 mt-1.5"
                              style={{ background: "linear-gradient(135deg,#00858F,#E6007E)" }}
                          />
                          <div>
                            <p className="text-lg uppercase tracking-wide text-white font-bold leading-tight">
                              {item.label}
                            </p>
                            {item.sub && (
                                <p className="text-sm text-white/45 mt-1 normal-case">{item.sub}</p>
                            )}
                          </div>
                        </div>
                        {i < arr.length - 1 && (
                            <div className="h-px ml-6" style={{ background: "rgba(255,255,255,0.1)" }} />
                        )}
                      </li>
                  ))}
                </ul>
              </GradientBorderCard>
            </div>
          </div>

          {/* ── CONTACT US ── */}
          <Link to="/contact">
            <div className="flex items-center justify-center pb-16">
              <button
                  className="rounded-full w-auto h-12 text-center text-white px-8 font-bold transform transition-transform duration-200 hover:scale-110"
                  style={{
                    background: "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
                  }}
              >
                CONTACT US
              </button>
            </div>
          </Link>
        </div>

        {isPopupOpen && (
            <OverlayForm
                formUrl="https://webforms.pipedrive.com/f/6UR9Re8nR5VKrsxbJHNTBDLcsXv6xjIStMZYDU4iiOvEJdEo7cZwg4M1uAm9NAG7WX"
                onClose={handleClosePopup}
            />
        )}
      </div>
  );
}
